<div class="stepper-body">
    <div class="body-title">
        <span>What is the property you are looking to refinance?</span>
    </div>
    <div *ngIf="isFromError" class="body-description" style="color: #d81b60;">
        <span>Your current agent is not licensed in {{stateCode}}. Please enter a new address.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <form [formGroup]="formGroup">
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <mat-label>{{ SubjectAddressInputs.Address1 }}</mat-label>
                        <input matInput [formControlName]="SubjectAddressInputs.Address1" [required]="true" />
                        <mat-error *ngIf="formGroup.get(SubjectAddressInputs.Address1)?.touched
                                        && formGroup.get(SubjectAddressInputs.Address1)?.hasError('required')">
                            {{ SubjectAddressInputs.Address1 }} is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <mat-label>{{ SubjectAddressInputs.City }}</mat-label>
                        <input matInput [formControlName]="SubjectAddressInputs.City" [required]="true" />
                        <mat-error *ngIf="formGroup.get(SubjectAddressInputs.City)?.touched
                                        && formGroup.get(SubjectAddressInputs.City)?.hasError('required')">
                            {{ SubjectAddressInputs.City }} is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="input-container">
                    <lgv-state-dropdown [userId]="agentId" [control]="formGroup.get(SubjectAddressInputs.State)"
                        label="State" [required]="true"
                        (noLicensedStates)="handleNoLicensedStates($event)"></lgv-state-dropdown>
                </div>
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <mat-label>{{ SubjectAddressInputs.Zip }}</mat-label>
                        <input matInput [formControlName]="SubjectAddressInputs.Zip" [required]="true" />
                        <mat-error *ngIf="formGroup.get(SubjectAddressInputs.Zip)?.touched
                                        && formGroup.get(SubjectAddressInputs.Zip)?.hasError('required')">
                            {{ SubjectAddressInputs.Zip }} is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary"
            [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>